import React from "react";
import AdminProducts from "../../components/Admin/AdminProducts";

export default function AdminProductsPage() {
  return <AdminProducts />;
}